import { Flex } from '@chakra-ui/react'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GET_WORKSHEETS } from 'store/worksheets'
import TableData from './components/TableData'

function Worksheets() {
  const dispatch = useDispatch()
  const initFetch = useCallback(() => {
    dispatch(GET_WORKSHEETS(''))
  }, [dispatch])
  useEffect(() => {
    initFetch()
  }, [initFetch])
  const lists = useSelector((state) => state.worksheets.lists)
  return (
    <Flex direction='column' pt={{ base: '80px', md: '75px' }}>
      <TableData
        title={'รายชื่อใบงาน'}
        captions={['ชื่อใบงาน', 'รายละเอียด', 'วิชา', 'ชั้นปีการศึกษา', 'ประเภท', 'สถานะ', '', '']}
        data={lists}
      />
    </Flex>
  )
}

export default Worksheets
